import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import EmptyHeartIcon from '../../assets/icon-heart-outline.svg?react';
import InfoIcon from '../../assets/icon-info.svg?react';
import ArrowDownwardsIcon from '../../assets/icon-cheveron.svg?react';
import { SummaryModal } from './SummaryModal';
import { getAiApp, toggleAppFavoriteStatus } from '@/services/aiApps';
import useElysiaStore from '@/app/elysia-store';

const AppActionsDropdown = ({ aiAppId }) => {
  const [open, setOpen] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [singleCardData, setSingleCardData] = useState<any>(null);
  const setAppFavourite = useElysiaStore((state) => state.setAppFavourite);
  const favoriteList = useElysiaStore((state) => state.favouriteAgent);
  const [markFavourite, setMarkFavourite] = useState(false);

  useEffect(() => {
    const favItem = favoriteList?.find((ele) => ele.agent_id === singleCardData?.agent_id);
    setMarkFavourite(favItem?.is_favourite ?? false);
  }, [favoriteList, singleCardData?.agent_id]);

  useEffect(
    () => {
      const getAppData = async () => {
        const app = await getAiApp(aiAppId);
        setSingleCardData(app);
      };
      getAppData();
    },
    //eslint-disable-next-line
    []
  );
  const handleToggleFavourite = async () => {
    const payload = { agent_id: aiAppId, is_favourite: !markFavourite };
    const response = await toggleAppFavoriteStatus(payload);
    if (response?.data?.status) {
      setAppFavourite(payload);
    }
    setMarkFavourite(!markFavourite);
  };
  return (
    <div>
      <div className="app-action-item">
        <Dropdown show={open} autoClose="outside" onToggle={(isOpen) => setOpen(isOpen)}>
          <Dropdown.Toggle as="span" className="ms-1 pt-1 cursor-pointer dropdown-toggle-no-caret">
            <ArrowDownwardsIcon className="arrow-icon" />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="action-menu">
            <Dropdown.Item
              onClick={handleToggleFavourite}
              className="w-100 item mb-1"
              disabled={singleCardData?.agent_status === 'unpublished'}
            >
              <span
                className={`me-2 ${
                  singleCardData?.agent_status === 'unpublished' ? 'opacity-50' : ''
                }`}
              >
                <EmptyHeartIcon />
              </span>
              {markFavourite ? 'Remove from Favourites' : 'Add to Favourites'}
            </Dropdown.Item>

            <Dropdown.Item onClick={() => setShowSummaryModal(true)} className="w-100 item">
              <span className="me-2 info-icon">
                <InfoIcon />
              </span>
              View App Info
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {showSummaryModal && (
        <SummaryModal
          cardData={singleCardData}
          showModal={showSummaryModal}
          setShowSummaryModal={setShowSummaryModal}
          tabName="in-app"
        />
      )}
    </div>
  );
};

export default AppActionsDropdown;
